import { useCallback } from 'react';
import useAjax from '@apis/useAjax';
import {
    GET_CLUB_PURCHASE_RECEIPT_OPTIONS_API,
    POST_CLUB_PURCHASE_RECEIPT_OVERVIEW_API,
    GET_CLUB_PURCHASE_RECEIPT_API,
    GET_CLUB_PURCHASE_RECEIPT_INVENTORY_RECORDS_API,
    POST_CLUB_PURCHASE_RECEIPT_API,
} from '@apis/apiPath';

/**
 * 店鋪進貨單相關 API Hook
 * 對應後端 ClubPurchaseReceiptController
 */
const useClubPurchaseReceiptApi = () => {
    const Ajax = useAjax();

    /**
     * 進貨單下拉式選單
     */
    const getClubPurchaseReceiptOptionsApi = useCallback(
        async (skipAll = false) => await Ajax.get(GET_CLUB_PURCHASE_RECEIPT_OPTIONS_API(skipAll)),
        // eslint-disable-next-line
        [],
    );

    /**
     * 取得進貨單分頁列表
     * @param {object} params 查詢參數 (ClubPurchaseReceiptPaginationRequestModel)
     *   - pageIndex, pageSize, startDate, endDate, purchaseStatus, sourceType, sortBy
     * @returns {Promise<{
     *   list: Array<{
     *     clubPurchaseReceipID: number,
     *     purchaseNo: string,
     *     purchaseStatus: number,
     *     sourceType: number|null,
     *     purchaseDate: string,
     *     deliveryDate: string|null,
     *     inspectionDeadline: string,
     *     quantity: number,
     *     actualQuantity: number
     *   }>,
     *   pageIndex: number,
     *   pageSize: number,
     *   totalCount: number,
     *   totalPage: number
     * }>} 後端 PaginationResponseModel<ClubPurchaseReceiptOverviewResponseModel>（JSON 為 camelCase）
     */
    const postClubPurchaseReceiptOverviewApi = useCallback(
        async (params) => await Ajax.post(POST_CLUB_PURCHASE_RECEIPT_OVERVIEW_API, params),
        // eslint-disable-next-line
        [],
    );

    /**
     * 取得進貨資訊
     * @param {number} receiptID 進貨單代碼
     */
    const getClubPurchaseReceiptApi = useCallback(
        async (receiptID) => await Ajax.get(GET_CLUB_PURCHASE_RECEIPT_API(receiptID)),
        // eslint-disable-next-line
        [],
    );

    /**
     * 取得入庫記錄
     * @param {number} receiptID 進貨單代碼
     */
    const getClubPurchaseReceiptInventoryRecordsApi = useCallback(
        async (receiptID) => await Ajax.get(GET_CLUB_PURCHASE_RECEIPT_INVENTORY_RECORDS_API(receiptID)),
        // eslint-disable-next-line
        [],
    );

    /**
     * 新增進貨單
     * @param {object} params 進貨單資訊 (ClubPurchaseReceiptRequestModel)
     */
    const postClubPurchaseReceiptApi = useCallback(
        async (params) => await Ajax.post(POST_CLUB_PURCHASE_RECEIPT_API, params),
        // eslint-disable-next-line
        [],
    );

    return {
        getClubPurchaseReceiptOptionsApi,
        postClubPurchaseReceiptOverviewApi,
        getClubPurchaseReceiptApi,
        getClubPurchaseReceiptInventoryRecordsApi,
        postClubPurchaseReceiptApi,
    };
};

export default useClubPurchaseReceiptApi;
